/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Slider from './slider';
import PrimaryNavItem from './primary-nav-item';
import SecondaryNavItem from './secondary-nav-item';
import styles from './styles.css';
import BannerMessage from '../banner-message';

const { getNavigationTree, store } = require('../../../lib/bputils').default;
const { gTagEvent } = require('../../../lib/global-site-tag').default;

const navTree = getNavigationTree();

class Navigation extends React.Component {
  state = {
    navigationItems: [],
    didMount: false,
  };

  componentDidMount = () => {
    this.setState(() => ({ ...navTree, didMount: true }));
  }

  handleOnNavigationMouseLeave = () => {
    this.setState(prevState => ({
      hoveredPrimaryNavItem: prevState.selectedPrimaryNavItem,
    }));
  }

  handleOnPrimaryNavMouseEnter = (navItemName) => {
    const { navigationItems } = this.state;
    const hoveredPrimaryNavItem = navigationItems.find(primaryNavItem => primaryNavItem.name === navItemName);
    if (hoveredPrimaryNavItem) {
      this.setState(() => ({
        hoveredPrimaryNavItem,
      }));
    }
  }

  handleTertiaryNavButtonClicked = (selectedSecondaryNavItem) => {
    if (selectedSecondaryNavItem.pageToggle) {
      gTagEvent('Page Toggle', `Clicked ${selectedSecondaryNavItem.pageToggle?.buttonText}`, null);
    }
    const toggledPath = selectedSecondaryNavItem.link;
    store.set(toggledPath, toggledPath);
    window.location.pathname = toggledPath;
  }

  render() {
    const { navigationItems, selectedPrimaryNavItem, selectedSecondaryNavItem, hoveredPrimaryNavItem, didMount } = this.state;
    const selectedPrimaryNav = hoveredPrimaryNavItem || selectedPrimaryNavItem;

    if (!didMount) {
      return (<div />);
    }

    let emergencyFeaturesCss = '';
    if (selectedPrimaryNav?.key === 'emergency') {
      emergencyFeaturesCss = styles.emergencyFeatures;
    }

    return (
      <>
        <div className={styles.navigationContainer} onMouseLeave={this.handleOnNavigationMouseLeave}>
          <div className={styles.primaryNavigation}>
            <Slider backgroundColor="#1a2022">
              {navigationItems.map(item => (
                <PrimaryNavItem
                  ref={(e) => { this[item.name] = e; }}
                  key={item.key}
                  menuId={item.key}
                  name={item.name}
                  iconName={item.iconName}
                  link={item.children[0].link}
                  active={item.name === selectedPrimaryNavItem?.name}
                  hover={item.name === hoveredPrimaryNavItem?.name}
                  handleMouseEnter={this.handleOnPrimaryNavMouseEnter}
                />
              ))}
            </Slider>
          </div>
          <div className={`${styles.secondaryNavigation} ${emergencyFeaturesCss}`}>
            <Slider backgroundColor="#0097A9">
              {(selectedPrimaryNav?.children || []).map(secondaryNavItem => (
                <SecondaryNavItem
                  key={secondaryNavItem.name}
                  parentMenuId={selectedPrimaryNav.key}
                  name={secondaryNavItem.name}
                  link={secondaryNavItem.link}
                  active={secondaryNavItem.name === selectedSecondaryNavItem?.name}
                />
              ))}
            </Slider>
          </div>
        </div>
        {!!selectedSecondaryNavItem?.pageToggle
          && (
            <div className={styles.tertiaryNavigation}>
              <BannerMessage
                mode="detailed"
                onClickButton={() => this.handleTertiaryNavButtonClicked(selectedSecondaryNavItem)}
                message={selectedSecondaryNavItem.pageToggle.buttonText}
                headerText={selectedSecondaryNavItem.pageToggle.headerText}
                // eslint-disable-next-line max-len
                secondaryText={selectedSecondaryNavItem.pageToggle.secondaryText}
              />
            </div>
          )}
      </>
    );
  }
}

export default Navigation;
